import gql from 'graphql-tag';

export const listJobQL = gql`
  query listJob {
    jobs: listJob {
      id
      date
      description
      client {
        id
        name
        picName
      }
    }
  }
`;
